import { WALLET_BUTTON_CLASSNAME } from 'src/components/ConnectWalletButtonsList/WalletButton';
import useDriftTheme from 'src/hooks/useDriftTheme';
import { DriftTheme } from 'src/environmentVariables/EnvironmentVariables';
import { useAppKit } from '@reown/appkit/react';

export const ReownWalletButton = () => {
	const { open: openAppKitModal } = useAppKit();

	const handleConnectReownWallet = () => {
		openAppKitModal({ view: 'Connect', namespace: 'solana' });
	};

	const isLightTheme = useDriftTheme() === DriftTheme.light;
	return (
		<button
			onClick={handleConnectReownWallet}
			className={WALLET_BUTTON_CLASSNAME}
		>
			<div className="flex items-center">
				<div className="mr-4 size-6">
					<img
						src={
							isLightTheme
								? '/assets/icons/reown-logo-negative.svg'
								: '/assets/icons/reown-logo.svg'
						}
						className="size-full"
					/>
				</div>
				<div className="text-left text-text-default">
					Social Login with Reown
				</div>
			</div>
		</button>
	);
};
